import type { O5AwsDeployerV1DeploymentKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const O5_DEPLOYMENT_BASE_PATH = getResolvedPath('/tech-ops/deployment');

export const getO5DeploymentPath: EntityPathBuilder<O5AwsDeployerV1DeploymentKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return O5_DEPLOYMENT_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.deploymentId) {
        return undefined;
      }

      return getResolvedPath(`${O5_DEPLOYMENT_BASE_PATH}/$deploymentId`, context?.keys);
    }
  }
};

export function getO5DeploymentDetailPath(deploymentId: string | undefined) {
  if (!deploymentId) {
    return undefined;
  }

  return getO5DeploymentPath({ kind: 'detail', keys: { deploymentId } });
}
